<div class="modal-header">
  <h4 class="modal-title">{{title}} Pregunta</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Cancelar')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <input type="text" class="form-control" id="inputPregunta" aria-describedby="preguntaHelp"
      placeholder="Ingrese la pregunta" [(ngModel)]="pregunta">
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger" (click)="activeModal.close('Cancelar')">Cancelar</button>
  <button type="button" class="btn btn-outline-primary" [disabled]="!pregunta || pregunta === ''"
    (click)="Aceptar()">Aceptar</button>
</div>
